import { useTranslations } from "use-intl";

import { PersistentDrawer } from "@/components/Drawer/PersistentDrawer";
import { SwipeableDrawer } from "@/components/Drawer/SwipeableDrawer";
import { TripTourPlan } from "@/features/trips/components/bookingFlow/tripDetails/TripTourPlanCard";
import type { TripDetails } from "@/features/trips/types/types";
import { formatCurrency } from "@/utils/currency";

type TripTourDrawerProps = {
  trip: TripDetails;
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
};

export function TripTourDrawer({
  trip,
  open,
  onClose,
  children,
}: TripTourDrawerProps) {
  const t = useTranslations();

  return (
    <SwipeableDrawer open={open} onClose={onClose}>
      <div className="pb-[var(--drawer-height,0)]">
        <h2 className="font-medium">
          {t("trips.tours.drawer.title", { city: trip.cities })}
        </h2>
        <p className="mb-4 text-sm text-text-tertiary">
          {t("trips.tours.drawer.subtitle")}
        </p>

        <TripTourPlan itineraries={trip.itineraries} />
      </div>

      <PersistentDrawer open={open}>
        <dl className="mb-4 flex items-center justify-between gap-2 text-sm">
          <dt>{t("trips.tours.drawer.priceNotice")}</dt>
          <dd className="text-end text-base font-bold">
            <bdi>+{formatCurrency(trip.tourPrice)}</bdi>
          </dd>
        </dl>

        <div className="flex gap-2">{children}</div>
      </PersistentDrawer>
    </SwipeableDrawer>
  );
}
